import type { ApplicationLocale } from 'types';

import { useUpdateProfile } from './use-update-profile';

export function useChangeLocale() {
  const { updateProfile } = useUpdateProfile();

  return (locale: ApplicationLocale) => updateProfile({ locale });
}
